module.exports = __webpack_public_path__ + "frontend/images/agents/phone-xs-f332a3e541f318228d14d6e978e5ad71.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/phone-xs.jpg
// module id = 349
// module chunks = 2